import { $$, on, toggleClass } from "../../utils/dom";

function handleHover(popup: HTMLElement, active: boolean): void {
  toggleClass(popup, "-isClosed", active);
}

export const onContentLoaded = (): void => {
  const cards = $$(".m-serviceCard");

  if (cards)
    cards.forEach((card) => {
      const popup: HTMLElement | null = card.querySelector(".a-popup");
      if (popup) {
        on(card, "mouseenter", () => handleHover(popup, false));
        on(card, "mouseleave", () => handleHover(popup, true));
      }
    });
};

if (process.env.NODE_ENV !== "development") {
  on(document, "DOMContentLoaded", onContentLoaded);
}
